import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models'

export interface IPhase {
  id: number
  player_id: number
  title: string
  description?: string
  start_date: string
  end_date: string
  goals?: Record<string, number>
  created_at?: string
  updated_at?: string
}

export interface IPhaseCreateData {
  player_id: number
  title: string
  description?: string
  start_date: string
  end_date: string
  goals?: Record<string, number>
}

export class PhasesApiService extends ApiService {
  static async getPhases(playerId: number): Promise<IServiceResponse<IPhase[]>> {
    return this.axios.get('phases', { params: { player_id: playerId } })
      .then((response: AxiosResponse<IServiceResponse<IPhase[]>>) => response.data)
  }

  static async getPhase(phaseId: number, params: object): Promise<IServiceResponse<IPhase>> {
    return this.axios.get(`phases/${phaseId}`, { params: params })
      .then((response: AxiosResponse<IServiceResponse<IPhase>>) => response.data)
  }

  static async createPhase(data: IPhaseCreateData): Promise<IServiceResponse<IPhase>> {
    return this.axios.post('phases', data)
      .then((response: AxiosResponse<IServiceResponse<IPhase>>) => response.data)
  }

  static async updatePhase(phaseId: number, data: Partial<IPhaseCreateData>): Promise<IServiceResponse<IPhase>> {
    return this.axios.put(`phases/${phaseId}`, data)
      .then((response: AxiosResponse<IServiceResponse<IPhase>>) => response.data)
  }

  static async deletePhase(phaseId: number): Promise<AxiosResponse> {
    return this.axios.delete(`phases/${phaseId}`).then(response => response.data)
  }
}
